import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDate(date) {
  if (!date) return '';
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(date));
}

export function formatDateTime(date) {
  if (!date) return '';
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export const DEAL_STAGES = [
  { id: 'lead', label: 'Lead', color: 'bg-zinc-500' },
  { id: 'qualified', label: 'Qualified', color: 'bg-blue-500' },
  { id: 'proposal', label: 'Proposal', color: 'bg-amber-500' },
  { id: 'negotiation', label: 'Negotiation', color: 'bg-purple-500' },
  { id: 'closed_won', label: 'Closed Won', color: 'bg-emerald-500' },
  { id: 'closed_lost', label: 'Closed Lost', color: 'bg-red-500' },
];

export const PROCUREMENT_SECTORS = [
  { id: 'infrastructure', label: 'Infrastructure' },
  { id: 'energy', label: 'Energy' },
  { id: 'telecommunication', label: 'Telecommunication' },
  { id: 'logistic', label: 'Logistic' },
  { id: 'transports', label: 'Transports' },
  { id: 'services', label: 'Services' },
];

export const PROCUREMENT_STATUSES = [
  { id: 'draft', label: 'Draft', color: 'bg-zinc-500' },
  { id: 'published', label: 'Published', color: 'bg-blue-500' },
  { id: 'evaluation', label: 'Evaluation', color: 'bg-amber-500' },
  { id: 'awarded', label: 'Awarded', color: 'bg-emerald-500' },
  { id: 'completed', label: 'Completed', color: 'bg-green-700' },
  { id: 'cancelled', label: 'Cancelled', color: 'bg-red-500' },
];

export const TASK_PRIORITIES = [
  { id: 'low', label: 'Low', color: 'text-zinc-500' },
  { id: 'medium', label: 'Medium', color: 'text-amber-500' },
  { id: 'high', label: 'High', color: 'text-red-500' },
];

export const TASK_STATUSES = [
  { id: 'pending', label: 'Pending' },
  { id: 'in_progress', label: 'In Progress' },
  { id: 'completed', label: 'Completed' },
  { id: 'cancelled', label: 'Cancelled' },
];
